export const getTestId = (id: string) => ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'data-test-id': id,
});
